import { render, staticRenderFns } from "./tipo-usuario.vue?vue&type=template&id=e5534436&scoped=true"
import script from "./tipo-usuario.vue?vue&type=script&lang=js"
export * from "./tipo-usuario.vue?vue&type=script&lang=js"
import style0 from "./tipo-usuario.vue?vue&type=style&index=0&id=e5534436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5534436",
  null
  
)

export default component.exports